define('drops/carouselTabControl/carouselTabControl',[
    'jquery',
    'underscore',
    'lq/drop',
    'lq/style',
    'lq/util'
], function ($, _, Drop, Style, util) {
    'use strict';

    var defaults = {
        data: {
            type: 'CarouselTabControl'
        }
    };

    function CarouselTabControl(options) {
        Drop.call(this, $('<div/>'), defaults, options);

        this.data.styles = this.data.tabStyles;

        var self = this;
        this.onChangeFunc = function (index) {
            self.$element.find('.carousel-tab-control-tab').eq(index).trigger('click');
        };
    }

    Drop.extend(CarouselTabControl, Drop);

    CarouselTabControl.typeName = 'CarouselTabControl';

    CarouselTabControl.prototype.getCarousel = function () {
        return this.data.carousel && this.piping.dropFactory.findDropByName(this.data.carousel);
    };

    CarouselTabControl.prototype.getTabData = function () {
        if (!this.carousel)
            return [];
        return _.chain(this.carousel.childDrops)
            .pluck('data')
            .where({ type: 'CarouselPanel' })
            .value();
    };

    CarouselTabControl.prototype.preRender = function () {
        this.piping.visibility.apply(this);
        this.formatter = this.piping.formatting.createFormatter(this.data.formatting);
        this.carousel = this.getCarousel();
        this.applyPosition();
    };

    CarouselTabControl.prototype.postRender = function () {
        this.renderTabs();
    };

    CarouselTabControl.prototype.renderTabs = function () {
        var self = this;

        var tabstyle = util.convertListOfKeyValuesToObject(self.data.tabStyles);
        this.carousel = this.getCarousel();
        
        _.each(this.getTabData(), function (tabData, index) {
            var $tab = $('<div />')
                .text(tabData.name)
                .width(self.data.tabX)
                .height(self.data.tabY)
                .addClass('boxToBorderSize')
                .addClass('carousel-tab-control-tab')
                .css({
                    cursor: 'pointer',
                    'float': 'left',
                    overflow: 'hidden',
                    wordWrap: 'break-word',
                    display: 'block',
                    lineHeight: 1
                })
                .appendTo(self.$element);

            if (tabstyle && tabstyle.normal) {
                Style.renderStyle(tabstyle.normal, self, $tab);
            } else {
                Style.renderStyles(self, null, $tab);
            }

            if (tabstyle && tabstyle.active && tabstyle.active.enabled) {
                if (index === self.carousel.getInitialIndex()) {
                    self.selectedTab = index;
                    Style.renderStyle(tabstyle.active, self, $tab);
                }
                $tab.on('click', function () {
                    if (!self.carousel.sliderActive) {
                        self.carousel.goToSlide(index);
                        self.selectedTab = index;
                        Style.renderStyle(tabstyle.normal, self, self.$element.find('.carousel-tab-control-tab'));
                        Style.renderStyle(tabstyle.active, self, $tab);
                    }
                });
                if (tabstyle.hover && tabstyle.hover.enabled) {
                    $tab
                        .on('mouseenter', function () {
                            if (self.selectedTab !== index) {
                                Style.renderStyle(tabstyle.hover, self, $tab);
                            }
                        })
                        .on('mouseleave', function () {
                            if (self.selectedTab !== index) {
                                Style.renderStyle(tabstyle.normal, self, $tab);
                            }
                        });
                }
            } else {
                if (index === self.carousel.getInitialIndex()) {
                    self.selectedTab = index;
                    $tab.addClass('active');
                }
                $tab.on('click', function () {
                    self.carousel.goToSlide(index);
                    $(this).addClass('active').siblings().removeClass('active');
                });
            }

        });
        if (this.carousel) {
            this.carousel.onChange(this.onChangeFunc);
        }
    };

    return CarouselTabControl;
});
